// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FileGenericFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from file-generic-filled.svg
 */
export default function FileGenericFilledIcon(
  props: FileGenericFilledIconProps,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FileGenericFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M11 0v3.5a.5.5 0 0 0 .41.492L11.5 4H15v11.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zM4.75 5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm0 2.75a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM4 11.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
        />
        <path
          fill="currentColor"
          d="m12.685.144 2.167 2.143a.5.5 0 0 1 .148.356V3h-2.75a.25.25 0 0 1-.25-.25V0h.333a.5.5 0 0 1 .352.144"
        />
      </g>
    </svg>
  );
}
